import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { TagType, DsiTag as Tag } from '../Product/Tag';
import { DsiSvgIcon as SvgIcon, IconType } from './SvgIcon';

interface Props {
  isFreeDelivery?: boolean;
  isSale?: boolean | number | undefined;
  isSecondHand?: boolean;
  isNew?: boolean | number;
  isVertical?: boolean;
  tagWidth?: number;
  tagHeight?: number;
  style?: React.CSSProperties;
  /** Optional className to add to existing classes */
  className?: string;
  hasGift?: boolean;
  hiddenSale?: boolean;
}

function Tags({
  isFreeDelivery,
  isSale,
  isSecondHand,
  isNew,
  isVertical = false,
  tagWidth = 50,
  tagHeight = 50,
  className,
  style,
  hasGift,
  hiddenSale
}: Props) {
  const isTag =
    !!isNew || !!isSale || !!isSecondHand || !!isFreeDelivery || !!hasGift || !!hiddenSale;

  return (
    <TagWrapper
      className={[``, className].join(' ')}
      style={style}
      isVertical={isVertical}
    > 
      {isTag && (
        !!isSecondHand ? 
          <Tag
            type={TagType.SECOND_HAND}
            text={
              <SvgIcon
                icon={IconType.recycled}
                width={tagWidth}
                height={tagHeight}
                fill="#dd9f45"
                title={__('Bazár')}
                viewBox="0 0 26 26"
              />
            }
          />:
        <>
          {!!isNew && (
            <Tag
              type={TagType.NEW}
              text={
                <SvgIcon
                  icon={IconType.new}
                  width={tagWidth}
                  height={tagHeight}
                  fill="#4d4d4d"
                  title={__('Novinka')}
                  viewBox="0 0 26 26"
                />
              }
            />
          )}
          {!!isSale && (
            <Tag
              type={TagType.SALE}
              text={
                <SvgIcon
                  icon={IconType.saleout}
                  width={tagWidth}
                  height={tagHeight}
                  fill="#ff1e45"
                  title={__('Akcia')}
                  viewBox="0 0 26 26"
                />
              }
            />
          )}

          {(!isSale && !!hiddenSale) && (
            <Tag
              type={TagType.DEAL}
              text={
                <SvgIcon
                  icon={IconType.deal}
                  width={tagWidth}
                  height={tagHeight}
                  fill="#ff1e45"
                  title={__('SUPER CENA')}
                  viewBox="0 0 26 26"
                />
              }
            />
          )}
          
          {!!isFreeDelivery && (
            <Tag
              type={TagType.FREE_DELIVERY}
              text={
                <SvgIcon
                  icon={IconType.delivery}
                  width={tagWidth}
                  height={tagHeight}
                  fill="#36bf91"
                  title={__('Doprava zadarmo')}
                  viewBox="0 0 26 26"
                />
              }
              title={__('Doprava zadarmo')}
            />
          )}
          {!!hasGift && (
            <Tag
              type={TagType.GIFT}
              text={
                <SvgIcon
                  icon={IconType.gift}
                  width={tagWidth}
                  height={tagHeight}
                  fill="orange"
                  title={__('Darček ku produktu')}
                  viewBox="0 0 26 26"
                />
              }
              title={__('Darček ku produktu')}
            />
          )}
        </>
      )}
    </TagWrapper>
  );
}

// export default Tags;
export { Tags as DsiTags };

const TagWrapper = styled.div<{ isVertical: boolean }>`
  display: flex;
  z-index: 5;
  ${({ isVertical }) =>
    isVertical
      ? `
        flex-direction: column;
        position: absolute;
        top: ${rem(16)};
        left: ${rem(16)};
      `
      : `flex-direction: row;`};
`;
